<script setup>
	const value = defineModel({ type: String, default: '' });

	const allowedChars = /[^А-Яа-яЁё0-9\s\-_.,!?'"()]/g;

	const handleInput = (e) => {
		let inputVal = e.target.value;

		if (inputVal.length > 500)
			inputVal = inputVal.slice(0, 500);

		const cleaned = inputVal.replace(allowedChars, '');

		value.value = cleaned;

		if (e.target.value !== cleaned) e.target.value = cleaned;
	};
</script>

<template>
	<div class="textarea-wr">
		<textarea
		name="comment"
		placeholder="Комментарий"
		:value="value"
		@input="handleInput"
		/>
		<span>{{ value.length }}/500</span>
	</div>
</template>

<style lang='scss'>
.textarea-wr {
	position: relative;

	textarea {
		width: 100%;
		height: 140px;
		resize: none;
		border: none;
		padding: 18px 22px;
		border-radius: 12px;
		font-size: 16px;
	}

	span {
		display: block;
		position: absolute;
		right: 22px;
		bottom: 18px;
		font-size: 12px;
		color: #D9D9D9;
	}
}
</style>